<!-- start banner Area -->
<section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                  background-size: cover;" id="home-section">
  <div class="container" style="padding: 100px 0px 100px 0px;">
    <div class="row">
      <div class="col-md-7">
        <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Postuler au poste de :</h1>
        <div class="custom-breadcrumbs">
          <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
          <a style=" color: #FF5A00 " routerLink="/job-list">Offres d'emploi</a> <span class="mx-2 slash">/</span>
          <span class="text-white"><strong>{{ job.getLibelle() }}</strong></span>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="container mt-5">
  <div class="row align-items-center mb-5">
    <div class="col-lg-10 mb-4 mb-lg-0">
      <div class="d-flex align-items-center">
        <div class="border p-2 d-inline-block mr-3 rounded">
          <img *ngIf="job.getCompany()['logo']" src="{{baseURL +job.getCompany()['logo']}}" width="110"
            style="height: 90%;" alt="Logo">
          <img *ngIf="!job.getCompany()['logo'] " src="assets/img/default-logo.svg" width="110" style="height: 90%;"
            alt="Logo">
        </div>
        <div>
          <h2 style="font-weight: bold; color: #00027d;font-size: 2rem !important;">{{ job.getLibelle() }}</h2>
          <div class="mb-2">
            <span style="font-weight: bold; color: #00027d;">Niveau d'étude : </span> <span
              *ngFor="let training of job.getJobsTrainings()"> {{
              training.getLevelOfStudy() }} en {{
              training.getTraining()['libelle'] }} |</span>
          </div>
          <h2 style="font-weight: bold; color: #00027d;font-size: 1rem !important;"> Niveau du processus: <strong
              style="color: #FF5A00;" *ngIf="(job.getJobLevel()==1)">Collecte</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==2)">Pré selections</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==3)">Tests </strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==4)">Entretiens</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==5)">Dépôt de rapport</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==6)">Cloture</strong>
          </h2>
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="row">
        <div class="col-8">
          <a (click)="addJobInBackup(job.getId())" class=" btn btn-danger "
            style="padding: 12px 20px; color: #fff;"><span class="icon-heart-o mr-2 text-danger"></span>Sauvegarder</a>
        </div>

      </div>
    </div>
  </div>


  <div class="row mb-4">

    <div class="col-lg-8">
      <div class="card" style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body">
          <div class="container">
            <div class="row d-flex justify-content-center mb-3" *ngIf="jobApplied">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  Désolé, vous avez déjà postulé à cette offre.
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center mb-3" *ngIf="totalFillingRate < 80 ">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  Désolé, vous n'êtes pas encore éligible à ce poste
                  veuillez completer vos informations de compte à hauteur de <strong>85%</strong> au moins en <a
                    class="" style="color: #ff5a00 !important;cursor: pointer;"
                    (click)="goToUpdateCandidateProfiles()">Cliquant
                    ici</a> avant de
                  pouvoir
                  postuler.
                </div>
              </div>
            </div>


            <!-- <div class="row d-flex justify-content-center mb-3" *ngIf="eligibiliy == false">
                    <div class="col-lg-12">
                      <div class="alert alert-danger" role="alert">
                        Vous ne disposez pas du profil requis pour postuler à cette offre.<a class=""
                          style="color: #ff5a00 !important" (click)="goToUpdateCandidateProfiles()">Cliquez ici pour
                          ajouter le profil</a>
                      </div>
                    </div>
                  </div> -->
            <div class="row d-flex justify-content-center mb-4" *ngIf="totalFillingRate > 70 ">
              <div class="col-lg-11  alert alert-info" role="alert">
                Souhaitez-vous mettre à jour vos informations avant de postuler ? <a class=""
                  style="color: #ff5a00 !important;cursor: pointer;" (click)="goToUpdateCandidateInfo()">Cliquez ici</a>
              </div>
            </div>
            <div class="row  justify-content-center mb-4">
              <div class="col-lg-12">
                <div class="  alert alert-info" role="alert"><a class="" target="_blank"
                    style="color: #ff5a00 !important;cursor: pointer;" (click)="goToUpdateCandidateTrainings()">Cliquez
                    ici</a> pour
                  Attacher en pièces jointes vos diplômes avant de postuler.
                </div>
              </div>
            </div>
            <div class="row  justify-content-center " *ngIf="addTraningsFiles">
              <div class="col-lg-12">
                <div class="  alert alert-danger" role="alert"> Les pièces jointes de certains diplômes ne sont pas
                  attachées. <a class="" target="_blank" style="color: #ff5a00 !important;cursor: pointer;"
                    (click)="goToUpdateCandidateTrainings()">Cliquez
                    ici</a> pour les Attacher.
                </div>
              </div>
            </div>
            <!-- Diplômes-->
            <div class="row">
              <div class="custom-control custom-radio col-md-12" *ngFor="let training of candidateTrainingList">
                <div
                  style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                  <input class="form-check-input" (change)="onCheckboxTrainingChange($event)" type="checkbox"
                    [value]="training['id']" id="">
                  <label class="form-check-label" for="">
                    {{ training['level_of_study'] }} en {{ training.getTrainings()['libelle']}}
                  </label>
                </div>
              </div>
            </div>

            <!-- verification des information avant soumission du formulaire  -->
            <div class="row d-flex justify-content-center">
              <form class="col-lg-12 pb-40 form-area" [formGroup]="applyJobForm">
                <div class="row  justify-content-center">
                  <div class="col-lg-12">
                    <div class="  alert alert-info" role="alert">
                      Choississez les expériences probantes ou <a class="" target="_blank"
                        style="color: #ff5a00 !important;;cursor: pointer;"
                        (click)="goToUpdateCandidateExperiences()">Cliquez
                        ici</a> pour
                      mettre à jour vos expériences ou en ajouter d'autres.
                    </div>
                  </div>
                </div>

                <div class="row justify-content-center  mb-3 ">
                  <div class="custom-control custom-radio col-lg-12"
                    *ngFor="let experience of experienceList; let i=index">
                    <div
                      style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                      <input class="form-check-input" type="checkbox" [value]="experience.getId()"
                        (change)="onCheckboxChange($event)" id="">
                      <label class="form-check-label" for="" style="text-transform: capitalize !important;">
                        {{ experience.getJobTitle() }} à {{ experience.getCompany() }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row  justify-content-center">
                  <div class="col-lg-12">
                    <div class="  alert alert-info" role="alert">
                      Choisissez les certificats probantes ou <a class="" target="_blank"
                        style="color: #ff5a00 !important;cursor: pointer;"
                        (click)="goToUpdateCandidateCertificates()">Cliquez
                        ici</a> pour
                      en ajouter d'autres
                    </div>
                  </div>
                </div>

                <!-- Certifcat-->
                <div class="row mb-2">
                  <div class="custom-control custom-radio col-md-12"
                    *ngFor="let certificat of candidateCertificateList">
                    <div
                      style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                      <input class="form-check-input" (change)="onCheckboxCertificatChange($event)" type="checkbox"
                        [value]="certificat['id']" id="">
                      <label class="form-check-label" for="">
                        {{ certificat['libelle']}}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="availability">Disponibilité</label>
                    <select class="form-control" id="availability" formControlName="availability">
                      <option value="">Selectionner...</option>
                      <option value="Immédiate">Immédiate</option>
                      <option value="1mois">1 mois</option>
                      <option value="1 à 3mois">1 à 3mois</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="mobility">Mobilité</label>
                    <select class="form-control" id="mobility" formControlName="mobility">
                      <option value="">Selectionner...</option>
                      <option value="Régionale">Régionale</option>
                      <option value="Nationale">Nationale</option>
                      <option value="Internationale">Internationale</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="status">Statut</label>
                    <select class="form-control" id="status" formControlName="status">
                      <option value="">Selectionner...</option>
                      <option value="En poste">En poste</option>
                      <option value="Sans emploi">Sans emploi</option>
                      <option value="En fin de contrat">En fin de contrat</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="current_salary">Salaire actuel <span>(1K = 1 000)</span></label>
                    <select class="form-control" id="current_salary" formControlName="current_salary">
                      <option value="">Selectionner...</option>
                      <option value="Moins de 100K">Moins de 100K (F CFA)</option>
                      <option value="100 à 200K">100 à 200K (F CFA)</option>
                      <option value="200 à 300K">200 à 300K (F CFA)</option>
                      <option value="300 à 400K">300 à 400K (F CFA)</option>
                      <option value="400 à 500K">400 à 500K (F CFA)</option>
                      <option value="Plus de 500K">Plus de 500K (F CFA)</option>
                    </select>
                  </div>


                  <div class="form-group col-md-6">
                    <label for="desired_salary">Salaire souhaité</label>
                    <select class="form-control" id="desired_salary" formControlName="desired_salary">
                      <option value="">Selectionner...</option>
                      <option value="Moins de 100K">Moins de 100K (F CFA)</option>
                      <option value="100 à 200K">100 à 200K (F CFA)</option>
                      <option value="200 à 300K">200 à 300K (F CFA)</option>
                      <option value="300 à 400K">300 à 400K (F CFA)</option>
                      <option value="400 à 500K">400 à 500K (F CFA)</option>
                      <option value="Plus de 500K">Plus de 500K (F CFA)</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="cover_letter">Lettre de motivation <span style="font-weight: bold; font-size: 12px;">(.pdf
                      < 1 Mo)</span></label>
                  <span class="form-control h-40px btn btn-success" (click)="chooseCoverLetter()">Joindre
                    fichier</span><span *ngIf="cover_letter != undefined"
                    style="font-size: 10px; font-weight: 700; color: green">
                    Super! Fichier
                    joint</span>
                </div>
                <div class="row d-flex ml-2">
                  <div class="">
                    <a style="font-weight: bold; color: #00027D !important;" routerLink="/cv/modele-cv-emploi"
                      target="_blank">Télécharger un modèle
                      de cv</a>
                  </div>
                </div>

                <div class="form-group ml-3 mt-4">
                  <div class="mr-4"
                    style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                    <input class="form-check-input" type="radio" name="choiceCV" id="withMyCV"
                      (click)="showOrHideInputField('withMyCV')" checked>
                    <label class="form-check-label" for="withMyCV" (click)="showOrHideInputField('withMyCV')">
                      Continuer avec mon CV
                    </label>
                  </div>
                  <div
                    style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                    <input class="form-check-input" type="radio" name="choiceCV" id="withOtherCV"
                      (click)="showOrHideInputField('withOtherCV')">
                    <label class="form-check-label" for="withOtherCV" (click)="showOrHideInputField('withOtherCV')">
                      Continuer avec un autre CV
                    </label>
                  </div>
                </div>

                <div class="form-group" id="uploadCVField" style="display: none;">
                  <label for="cv_path">Curriculum vitae<span style="color: red">**</span><span
                      style="font-weight: bold; font-size: 12px;">(.pdf < 1 Mo)</span></label>
                  <span class="form-control h-40px btn btn-success" (click)="chooseCurriculumVitae()">Joindre
                    fichier</span><span *ngIf="curriculum_vitae != undefined"
                    style="font-size: 10px; font-weight: 700; color: green"> Super! Fichier joint</span>
                </div>
                <div *ngIf="!jobApplied && totalFillingRate > 75 ">
                  <button type="button" class="btn btn-submit text-white mb-4" (click)="onSubmitJobApply()"
                    *ngIf="!applyJobIsLoading">Envoyer</button>
                  <span style="color: red" disabled *ngIf="applyJobIsLoading">Veuillez patienter...</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="bg-light p-3 border rounded mb-4">
        <h3 class="mt-3 h5 pl-3 mb-3 " style="font-weight: bold; color: #00027d;font-size: 1.625rem;">
          Infromations sur l'offre</h3>
        <ul class="list-unstyled pl-3 mb-0">
          <li class="mb-2"><strong class="text-black">Type d'emploi :</strong> {{ job.getTypeJob()
            }}</li>
          <li class="mb-2"><strong class="text-black">Année d'Expérience :</strong> {{ job.getYearOfExperience() }}
            <span *ngIf="job.getYearOfExperience() != 'Sans expérience'"></span>,
            <span class="lnr lnr-map-marker"></span>
          </li>
          <li class="mb-2"><strong class="text-black">Adresse :</strong> {{
            job.getCity() }}, {{ job.getCountry() }}</li>
          <li class="mb-2"><strong class="text-black">Date limite : </strong>{{ job.getExpirationDate()
            }}</li>
        </ul>
      </div>

      <div class="bg-light p-3 border rounded" style="">
        <h3 class="  mt-3 h5  mb-3 " style="font-weight: bold; color: #00027d;font-size: 1.625rem;">Partager l'avis</h3>
        <div class="social-share mt-2">
          <a target="_blank" href="https://www.facebook.com/talentsplusafrique" style="margin-right: 10px"><img
              src="assets/img/facebook1.svg" width="20"></a>
          <a target="_blank" href="https://www.linkedin.com/in/talents-plus-groupe-b325887a/"
            style="margin-right: 10px"><img src="assets/img/linkedin1.svg" width="20"></a>
          <a target="_blank" href="https://twitter.com/TalentsPlus"><img src="assets/img/twitter1.svg" width="20"></a>
        </div>
      </div>
      <br>
      <!-- <img width="100%" src="assets/img/ban-pub.jpg"> -->

    </div>
  </div>
</section>
<section
  style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
  <div class="container">
    <app-autresites></app-autresites>
  </div>
</section>

<!-- <section class=" fjCRKo mb-5">
  <img class="sc-4k3xr3-0 llrJEY" src="assets/img/postuler.jpg" sizes="100vm" alt="">
  <div class="sc-1rpwfyc-0 iMiWpR">
    <a data-testid="job-header-organization-link-logo" class="sc-19vdx99-0 ezBbTx">

      <h3 data-testid="job-header-organization-title" class="sc-12bzhsi-11 iehcjE">{{ job.getCompany()['acronym'] }}
        recrute
      </h3>
    </a>
    <h1 class="sc-12bzhsi-3 jsHMkb">{{ job.getLibelle() }}</h1>
    <ul data-testid="job-header-metas" class="sc-16yjgsd-4 kQXuzS">

      <li class="sc-16yjgsd-0 dalnlt stroked">
        <span style="font-weight: bold; margin-right: 5px;">Expire le </span>
        <span class="badge badge-danger">{{
          job.getExpirationDate()
          }}</span>

      </li>
      <li class="sc-16yjgsd-0 dalnlt"><span role="img" class="sc-16yjgsd-1 hAHnJj"><i name="location"
            class="sc-fyBusP gYmksc"></i></span><span class="sc-16yjgsd-3 cToOtz"><a color="light.900"
            rel="noopener noreferrer" target="_blank" font-weight="regular"
            class="sc-Dmqmp SHbsk sc-dxtBLK lineAP"><span class="wui-text">{{ job.getCity() }}, {{ job.getCountry()
              }}</span></a></span></li>

      <li class="sc-16yjgsd-0 dalnlt"><span role="img" class="sc-16yjgsd-1 hAHnJj"><i name="education_level"
            class="sc-fyBusP cEdpqp"></i></span><span class="sc-16yjgsd-3 eJxlVj"><span>Éducation : </span><span
            *ngFor="let training of job.getJobsTrainings()"> {{
            training.getLevelOfStudy() }} en {{
            training.getTraining()['libelle'] }} |</span></span></li>
      <li class="sc-16yjgsd-0 dalnlt"><span class="sc-16yjgsd-3 eJxlVj"><span> </span><span>&gt; {{
            job.getYearOfExperience() }} d'expérience</span></span></li>
    </ul>
  </div>

</section>


<section class="container">
  <div class="details">
    <div class="side-left">
      <div data-testid="job-summary-section-organization" class="sc-17gqtt5-0 emWsbY">
        <h4 style="font-size: 0.6875rem !important;" class="sc-17gqtt5-2 Jfzsf"><span>L'entreprise</span></h4><a
          data-testid="job-header-organization-link-logo" class="sc-19vdx99-0 ezBbTx" style="    margin-top: -40px;">
          <div size="30" class="sc-19vdx99-1 iuiJPo">
          </div>
          <h4 data-testid="job-summary-organization-title" class="sc-17gqtt5-6 fmXfcH">{{ job.getCompany()['acronym'] }}
          </h4>
        </a>
        <div class="" style="">
          <img src="{{baseURL +job.getCompany()['logo']}}" width="110" style="height: 90%;" alt="">
        </div>
        <div>
          <p>{{ job.getCompany()['nb_person']
            }} salariés</p>
        </div>
        <div data-testid="job-summary-section-job" class="sc-17gqtt5-0 emWsbY">
          <h4 style="font-size: 0.6875rem !important;" class="sc-17gqtt5-2 Jfzsf"><span>Le poste</span></h4>
          <h4 data-testid="job-summary-job-title" class="sc-17gqtt5-7 ZfceX">{{ job.getLibelle() }}</h4>
          <p style="    font-size: 0.875rem;"><a color="dark.200" rel="noopener noreferrer" target="_blank"
              display="inline" font-weight="400" class="sc-Dmqmp iIolbJ sc-dxtBLK krLavW"><span class="wui-text"><img
                  src="assets/img/lieu.svg"> {{
                job.getCity() }}, {{ job.getCountry() }}</span></a></p>
          <p style="    font-size: 0.875rem;"><span>Éducation : </span><span
              *ngFor="let training of job.getJobsTrainings()">{{
              training.getLevelOfStudy() }} en
              {{ training.getTraining()['libelle'] }} ou</span></p>
          <p style="font-size: 0.875rem;"><span>Expérience :
            </span><span>&gt; {{ job.getYearOfExperience() }}
              ans</span></p>
        </div>
      </div>

    </div>
    <div class="centre">
     
      <section class="service-area section-gap" id="service">
        <div class="container">
          <div class="row d-flex justify-content-center mb-3" *ngIf="jobApplied">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert">
                Désolé, vous avez déjà postulé à cette offre.
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center mb-3" *ngIf="totalFillingRate < 80 ">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert">
                Désolé, vous n'êtes pas encore éligible à ce poste
                veuillez completer vos informations de compte à hauteur de <strong>85%</strong> au moins en <a class=""
                  style="color: #ff5a00 !important;cursor: pointer;" (click)="goToUpdateCandidateProfiles()">Cliquant
                  ici</a> avant de
                pouvoir
                postuler.
              </div>
            </div>
          </div>


          <div class="row d-flex justify-content-center mb-3" *ngIf="eligibiliy == false">
            <div class="col-lg-12">
              <div class="alert alert-danger" role="alert">
                Vous ne disposez pas du profil requis pour postuler à cette offre.<a class=""
                  style="color: #ff5a00 !important" (click)="goToUpdateCandidateProfiles()">Cliquez ici pour
                  ajouter le profil</a>
              </div>
            </div>
          </div> 
          <div class="row d-flex justify-content-center mb-2" *ngIf="totalFillingRate > 70 ">
            <div class="col-lg-11  alert alert-info" role="alert">
              Souhaitez-vous mettre à jour vos informations avant de postuler ? <a class=""
                style="color: #ff5a00 !important;cursor: pointer;" (click)="goToUpdateCandidateInfo()">Cliquez ici</a>
            </div>
          </div>
          <div class="row  justify-content-center mb-4">
            <div class="col-lg-12">
              <div class="  alert alert-info" role="alert"><a class="" target="_blank"
                  style="color: #ff5a00 !important;cursor: pointer;" (click)="goToUpdateCandidateTrainings()">Cliquez
                  ici</a> pour
                Attacher en pièces jointes vos diplômes avant de postuler.
              </div>
            </div>
          </div>
          <div class="row  justify-content-center mb-4" *ngIf="addTraningsFiles">
            <div class="col-lg-12">
              <div class="  alert alert-danger" role="alert"> Les pièces jointes de certains diplômes ne sont pas
                attachées. <a class="" target="_blank" style="color: #ff5a00 !important;cursor: pointer;"
                  (click)="goToUpdateCandidateTrainings()">Cliquez
                  ici</a> pour les Attacher.
              </div>
            </div>
          </div>
    
          <div class="row mb-5">
            <div class="custom-control custom-radio col-md-12" *ngFor="let training of candidateTrainingList">
              <div
                style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                <input class="form-check-input" (change)="onCheckboxTrainingChange($event)" type="checkbox"
                  [value]="training['id']" id="">
                <label class="form-check-label" for="">
                  {{ training['level_of_study'] }} en {{ training.getTrainings()['libelle']}}
                </label>
              </div>
            </div>
          </div>

      
          <div class="row d-flex justify-content-center">
            <form class="col-lg-12 pb-40 form-area" [formGroup]="applyJobForm">
              <div class="row  justify-content-center">
                <div class="col-lg-12">
                  <div class="  alert alert-info" role="alert">
                    Choississez les expériences probantes ou <a class="" target="_blank"
                      style="color: #ff5a00 !important;;cursor: pointer;"
                      (click)="goToUpdateCandidateExperiences()">Cliquez ici</a> pour
                    mettre à jour vos expériences ou en ajouter d'autres.
                  </div>
                </div>
              </div>

              <div class="row justify-content-center  mb-3 ">
                <div class="custom-control custom-radio col-lg-12"
                  *ngFor="let experience of experienceList; let i=index">
                  <div
                    style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                    <input class="form-check-input" type="checkbox" [value]="experience.getId()"
                      (change)="onCheckboxChange($event)" id="">
                    <label class="form-check-label" for="" style="text-transform: capitalize !important;">
                      {{ experience.getJobTitle() }} à {{ experience.getCompany() }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row  justify-content-center">
                <div class="col-lg-12">
                  <div class="  alert alert-info" role="alert">
                    Choisissez les certificats probantes ou <a class="" target="_blank"
                      style="color: #ff5a00 !important;cursor: pointer;"
                      (click)="goToUpdateCandidateCertificates()">Cliquez ici</a> pour
                    en ajouter d'autres
                  </div>
                </div>
              </div>

              <div class="row mb-2">
                <div class="custom-control custom-radio col-md-12" *ngFor="let certificat of candidateCertificateList">
                  <div
                    style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                    <input class="form-check-input" (change)="onCheckboxCertificatChange($event)" type="checkbox"
                      [value]="certificat['id']" id="">
                    <label class="form-check-label" for="">
                      {{ certificat['libelle']}}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="availability">Disponibilité</label>
                  <select class="form-control" id="availability" formControlName="availability">
                    <option value="">Selectionner...</option>
                    <option value="Immédiate">Immédiate</option>
                    <option value="1mois">1 mois</option>
                    <option value="1 à 3mois">1 à 3mois</option>
                  </select>
                </div>

                <div class="form-group col-md-6">
                  <label for="mobility">Mobilité</label>
                  <select class="form-control" id="mobility" formControlName="mobility">
                    <option value="">Selectionner...</option>
                    <option value="Régionale">Régionale</option>
                    <option value="Nationale">Nationale</option>
                    <option value="Internationale">Internationale</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="status">Statut</label>
                  <select class="form-control" id="status" formControlName="status">
                    <option value="">Selectionner...</option>
                    <option value="En poste">En poste</option>
                    <option value="Sans emploi">Sans emploi</option>
                    <option value="En fin de contrat">En fin de contrat</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="current_salary">Salaire actuel <span>(1K = 1 000)</span></label>
                  <select class="form-control" id="current_salary" formControlName="current_salary">
                    <option value="">Selectionner...</option>
                    <option value="Moins de 100K">Moins de 100K (F CFA)</option>
                    <option value="100 à 200K">100 à 200K (F CFA)</option>
                    <option value="200 à 300K">200 à 300K (F CFA)</option>
                    <option value="300 à 400K">300 à 400K (F CFA)</option>
                    <option value="400 à 500K">400 à 500K (F CFA)</option>
                    <option value="Plus de 500K">Plus de 500K (F CFA)</option>
                  </select>
                </div>


                <div class="form-group col-md-6">
                  <label for="desired_salary">Salaire souhaité</label>
                  <select class="form-control" id="desired_salary" formControlName="desired_salary">
                    <option value="">Selectionner...</option>
                    <option value="Moins de 100K">Moins de 100K (F CFA)</option>
                    <option value="100 à 200K">100 à 200K (F CFA)</option>
                    <option value="200 à 300K">200 à 300K (F CFA)</option>
                    <option value="300 à 400K">300 à 400K (F CFA)</option>
                    <option value="400 à 500K">400 à 500K (F CFA)</option>
                    <option value="Plus de 500K">Plus de 500K (F CFA)</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="cover_letter">Lettre de motivation <span style="font-weight: bold; font-size: 12px;">(.pdf <
                      1 Mo)</span></label>
                <span class="form-control h-40px btn btn-success" (click)="chooseCoverLetter()">Joindre
                  fichier</span><span *ngIf="cover_letter != undefined"
                  style="font-size: 10px; font-weight: 700; color: green"> Super! Fichier
                  joint</span>
              </div>
              <div class="row d-flex ml-2">
                <div class="">
                  <a style="font-weight: bold; color: #00027D !important;" routerLink="/cv/modele-cv-emploi"
                    target="_blank">Télécharger un modèle
                    de cv</a>
                </div>
              </div>

              <div class="form-group ml-3 mt-4">
                <div class="mr-4"
                  style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                  <input class="form-check-input" type="radio" name="choiceCV" id="withMyCV"
                    (click)="showOrHideInputField('withMyCV')" checked>
                  <label class="form-check-label" for="withMyCV" (click)="showOrHideInputField('withMyCV')">
                    Continuer avec mon CV
                  </label>
                </div>
                <div
                  style="display: flex; flex-wrap: nowrap; flex-direction: column; align-items: flex-start; justify-content: center;">
                  <input class="form-check-input" type="radio" name="choiceCV" id="withOtherCV"
                    (click)="showOrHideInputField('withOtherCV')">
                  <label class="form-check-label" for="withOtherCV" (click)="showOrHideInputField('withOtherCV')">
                    Continuer avec un autre CV
                  </label>
                </div>
              </div>

              <div class="form-group" id="uploadCVField" style="display: none;">
                <label for="cv_path">Curriculum vitae<span style="color: red">**</span><span
                    style="font-weight: bold; font-size: 12px;">(.pdf < 1 Mo)</span></label>
                <span class="form-control h-40px btn btn-success" (click)="chooseCurriculumVitae()">Joindre
                  fichier</span><span *ngIf="curriculum_vitae != undefined"
                  style="font-size: 10px; font-weight: 700; color: green"> Super! Fichier joint</span>
              </div>
              <div *ngIf="!jobApplied && totalFillingRate > 75 ">
                <button type="button" class="btn btn-submit text-white mb-4" (click)="onSubmitJobApply()"
                  *ngIf="!applyJobIsLoading">Envoyer</button>
                <span style="color: red" disabled *ngIf="applyJobIsLoading">Veuillez patienter...</span>
              </div>
            </form>
          </div>
        </div>
      </section>
     
    </div>
    <div class="side-right">
      <img width="100%" src="assets/img/ban-pub.jpg">
    </div>
  </div>
</section> -->